import React from 'react';
import cx from 'classnames';

export const DividerElement = function FromElement({ element }) {
  return (
    <>
      <div
        className={cx('form-control-divider', {
          isVisible: element.options.isVisible,
        })}
      ></div>
    </>
  );
};
